export class Usuario
    {
        public UsuarioId : string;
        public Login : string;
        public Nome : string;
        public Email : string;
        public ChaveAcesso : string;
        public Senha : string;
        public Papel : string;
        public CodTabela : string;
        public Vendedor : any;
        public VendedorFK : string;
        public liberaApi: boolean;
        public ativo: boolean;
        public dirFtp: string;
        public cpfCnpj: string;
        public visualizaPromocao: boolean;
        public isDistribuidor: boolean;

        public Assing(item)
        {
            this.UsuarioId = item.usuarioId;
            this.Nome = item.nome;
            this.Login = item.login;
            this.Email = item.email;
            this.ChaveAcesso = item.chaveAcesso;
            this.Senha = item.senha;
            this.Papel = item.papel;
            this.CodTabela = item.codTabela;
            this.Vendedor = item.vendedor;
            this.VendedorFK = item.vendedorFK;
            this.liberaApi = item.liberaApi;
            this.ativo = item.ativo;
            this.dirFtp = item.dirFtp;
            this.cpfCnpj = item.cpfCnpj;
            this.visualizaPromocao = item.visualizaPromocao;
            this.isDistribuidor = item.isDistribuidor;
        }


    }
